export default {
  path: '/tool_heads',
  name: 'tool_heads',
  component: () => import('../components/toolhead/Layout'),
  redirect: { name: 'ToolHeadList' },
  meta: {
    breadcrumb: 'toolhead.toolheads',
  },
  children: [
    {
      name: 'ToolHeadList',
      path: '',
      component: () => import('../views/toolhead/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ToolHeadCreate',
      path: 'new',
      component: () => import('../views/toolhead/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ToolHeadUpdate',
      path: ':id/edit',
      component: () => import('../views/toolhead/Update'),
      meta: {
        breadcrumb: 'toolhead.toolhead',
      },
    },
    {
      name: 'ToolHeadShow',
      path: ':id',
      component: () => import('../views/toolhead/Show'),
      meta: {
        breadcrumb: 'toolhead.toolhead',
      },
    }
  ]
};
